export interface Person_Tahghigh_Interface {
  id:number,
  person_id:number,
  title:String,
  tarikh:String,
  nasher:String,
  link:String,
}

export function Empty_Person_Tahghigh_Interface(){
  return{
    id:0,
    person_id:0,
    title:'',
    tarikh:'',
    nasher:'',
    link:''
  }
}
